import Box from "@mui/material/Box";
import { IconButton, MenuItem } from "material-ui";
import { FormControl, InputAdornment, InputLabel, Select } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers-v6";

const FailedReasonSelected = ({
  isSmallerThanTablet = false,
  dataSearch = {},
  setDataSearch = () => {},
}) => {
  const reasonFailed = [
    "สินค้าไม่พร้อมส่ง",
    "ลูกค้าขอให้ยกเลิกรายการ",
    "ติดต่อลูกค้าไม่ได้",
    "ร้านค้าใช้เวลาเตรียมสินค้านานเกินไป",
    "ร้านค้าไม่ตอบกลับ",
    "ค่าส่งแพงเกินไป",
    "เปลี่ยนใจ",
    "ทำรายการผิดพลาด",
    "อื่นๆ",
  ];

  return (
    <Box
      sx={{
        minWidth: 200,
        display: isSmallerThanTablet ? "none" : "flex",
      }}
    >
      <FormControl fullWidth>
        <InputLabel>สาเหตุที่ยกเลิก</InputLabel>
        <Select
          value={dataSearch.failedReason}
          label="failedReason"
          onChange={(e) =>
            setDataSearch({
              ...dataSearch,
              failedReason: e.target.value,
              page: 0,
            })
          }
          endAdornment={
            dataSearch.failedReason && (
              <InputAdornment sx={{ marginRight: "10px" }} position="end">
                <IconButton
                  onClick={() => {
                    setDataSearch({
                      ...dataSearch,
                      failedReason: "",
                      page: 0,
                    });
                  }}
                >
                  <ClearIcon
                    sx={{
                      "&.MuiSvgIcon-root": {
                        fill: "#6C6C70",
                      },
                    }}
                  />
                </IconButton>
              </InputAdornment>
            )
          }
        >
          {reasonFailed.map((item) => (
            <MenuItem value={item} key={item}>
              {item}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default FailedReasonSelected;
